import { useEffect, useState } from 'react';
import { getUnixTime } from 'date-fns';
import useViewer from '@hooks/useViewer';

const useEventsFutureFilters = () => {
    const { viewer } = useViewer();
    const [filters, setFilters] = useState('');

    useEffect(() => {
        if (!viewer) {
            return;
        }

        const today = getUnixTime(new Date());
        setFilters(`created_at_timestamp > ${today}`);
    }, [viewer]);

    return { filters };
};

export default useEventsFutureFilters;
